import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  return (
    <div className="pagination">
      <button 
        className="pagination-btn" 
        onClick={handlePrev} 
        disabled={currentPage === 1}
      >
        ‹
      </button>
      
      <span className="pagination-info">
        {currentPage} of {totalPages}
      </span>
      
      <button 
        className="pagination-btn" 
        onClick={handleNext} 
        disabled={currentPage === totalPages}
      >
        ›
      </button>
    </div>
  );
};

export default Pagination;
